import { toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

const hideMessagesList = ["Invalid Token."]

export const responseHandler = (response: any) => {
  const { status, data, errors } = response || {}

  let updatedData = data?.data || data || response

  if ([200, 201].includes(status)) {
    const { message } = updatedData || {}
    if (message && !hideMessagesList.includes(message)) {
    }

    return updatedData ?? null
  }

  if (errors?.length) {
    errors.forEach((err: any, i: number) => {
      if (hideMessagesList.includes(err)) {
        return
      }
      toast.error(err, {
        autoClose: 3000,
        style: {
          backgroundColor: "#FFF5F5",
          color: "#991B1B",
          borderRadius: "0.8rem",
          border: "1px solid #ef171563",
        },
        progressClassName: "custom-progress-bar",
        pauseOnFocusLoss: false,
      })
    })
    return {
      errors: errors,
    }
  }

  toast.error("Server error", {
    autoClose: 3000,
    style: {
      backgroundColor: "#FFF5F5",
      color: "#991B1B",
      borderRadius: "0.8rem",
      border: "1px solid #ef171563",
    },
    progressClassName: "custom-progress-bar",
    pauseOnFocusLoss: false,
  })
  return {
    errors: ["Server error"],
  }
}
